import React from 'react';

import {
  Alert,
  Loading,
  AdminButton,
  IFrameModal,
  useRestaurantHomeView,
  MAX_MENU_RETRIES,
  MAX_MENU_RETRY_DELAY,
} from '@fingermarkglobal/cringer.components';

import { PrimaryHome } from '../../components/stateless/primary-home';
import { SecondaryHome } from '../../components/stateless/secondary-home';

const CustomHomeView = () => {
  const {
    t,
    card,
    cash,
    icons,
    state,
    retry,
    isOnline,
    languages,
    healthMsg,
    isCurrentLang,
    primaryAction,
    secondaryAction,
    onAdminActivate,
    showSecondaryHome,
    onChangeLanguage,
    showSecondaryAction,
    accessibilityEnabled,
    termsAndConditionsURL,
    showTermsAndConditionsModal,
    showTermsAndConditionsButton,
    onCloseTermsAndConditionsModal,
    setShowTermsAndConditionsModal,
    retryAttempt,
  } = useRestaurantHomeView();

  const params = {
    t,
    card,
    cash,
    icons,
    healthMsg,
    languages,
    primaryAction,
    isCurrentLang,
    secondaryAction: showSecondaryAction && secondaryAction,
    onChangeLanguage,
    accessibilityEnabled,
    termsAndConditionsURL,
    showTermsAndConditionsModal,
    showTermsAndConditionsButton,
    onCloseTermsAndConditionsModal,
    setShowTermsAndConditionsModal,
  };

  return (
    <div className={`flex flex-col items-center justify-center h-full`}>
      <AdminButton onActivate={onAdminActivate} />

      {state?.matches('loading') ||
        (state?.matches('populating') && <Loading isFirstLoad={true} />)}

      {state?.matches('failure') && (
        <Alert
          type="danger"
          message={state.context.message}
          additionalMessage={
            retryAttempt > MAX_MENU_RETRIES
              ? 'Press the retry button to manually recover the kiosk'
              : `Kiosk will try to recover itself in ${MAX_MENU_RETRY_DELAY} seconds`
          }
          onRetryAction={retry}
        />
      )}

      {state?.matches('success') && (
        <>
          <IFrameModal
            url={termsAndConditionsURL}
            onClose={onCloseTermsAndConditionsModal}
            showModal={showTermsAndConditionsModal}
            t={t}
            className="home-page-iframe"
          />
          {!isOnline ? (
            <Alert type="warning" message={t('homeConnectivityIssues')} />
          ) : showSecondaryHome ? (
            <SecondaryHome {...params} />
          ) : (
            <PrimaryHome {...params} />
          )}
        </>
      )}
    </div>
  );
};

export { CustomHomeView };
